// extracted by mini-css-extract-plugin
export var MainContainer = "WhatsAppButton-module--MainContainer--6a6a5";
export var WhatsappSection = "WhatsAppButton-module--WhatsappSection--b715e";